import { render, staticRenderFns } from "./Staffonly.vue?vue&type=template&id=137beb6a&scoped=true"
import script from "./Staffonly.vue?vue&type=script&lang=js"
export * from "./Staffonly.vue?vue&type=script&lang=js"
import style0 from "./Staffonly.vue?vue&type=style&index=0&id=137beb6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137beb6a",
  null
  
)

export default component.exports